export default __webpack_public_path__ + "1a6ec4fce5e6458af0958e81b47482c8.png";